// extracted by mini-css-extract-plugin
export var readonly = "_ga-1";
export var star = "_ga-0";